export default "__VITE_ASSET__CtgUfyJ5__"